module.exports = __webpack_public_path__ + "static/media/id3-wild_routine_v04.ca1dbb7b.jpg";